import { CAPTURE_CONFIG } from './config';
import { loadImage } from './rasterizeSvg';
import logoUrl from '../../../assets/logos/refrag-horz-fill.svg';

// Refrag logo bottom-right, 12% of the image width.
// eslint-disable-next-line import-x/prefer-default-export
export async function drawWatermark(ctx, { width, height, scale = 1 }) {
  if (!CAPTURE_CONFIG.watermark) return;

  const logo = await loadImage(logoUrl);
  const logoWidth = Math.round(width * scale * 0.12);
  const logoHeight = Math.round((logoWidth * logo.naturalHeight) / logo.naturalWidth);
  const margin = 16 * scale;

  ctx.save();
  ctx.globalAlpha = 0.8;
  ctx.drawImage(
    logo,
    width * scale - margin - logoWidth,
    height * scale - margin - logoHeight,
    logoWidth,
    logoHeight,
  );
  ctx.restore();
}
